module.exports = __webpack_public_path__ + "media/images/luggage-57f172b9b77118b5a5944250fadc812a.jpg";